export default class Context {
  /**
   * Create new Context and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  isSelected (key) {
    return typeof this[key] !== 'undefined' && this[key].id !== null
  }

  /**
   * @return {string|null}
   */
  endpoint (segments = []) {
    return [
      this.isSelected('partner') && segments.includes('partner') ? `partners/${this.partner.id}` : null,
      this.isSelected('business') && segments.includes('business') ? `businesses/${this.business.id}` : null,
      this.isSelected('merchant') && segments.includes('merchant') ? `merchants/${this.merchant.id}` : null,
      this.isSelected('configuration') && segments.includes('configuration') ? `configurations/${this.configuration.id}` : null
    ].filter(Boolean).join('/')
  }
}
